import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import './ComingSoonModule.css';

const MODULE_CONFIG = {
  'ai-teacher': {
    title: 'AI Teacher',
    icon: '/img/modules/roboTeacher.png',
    tagline: 'Your intelligent teaching assistant is on the way.',
    gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)',
    accent: '#764ba2',
  },
  'ai-paper-maker': {
    title: 'AI Paper Maker',
    icon: '/img/modules/aiExamGenerator.png',
    tagline: 'Smart exam generation powered by AI — coming soon.',
    gradient: 'linear-gradient(135deg, #11998e 0%, #38ef7d 50%, #06beb6 100%)',
    accent: '#11998e',
  },
  'edu-scan': {
    title: 'EDU Scan',
    icon: '/img/modules/scanner.png',
    tagline: 'Scan, digitize, and organize — all in one place.',
    gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 50%, #43e97b 100%)',
    accent: '#4facfe',
  },
};

const ComingSoonModule = () => {
  const { module } = useParams();
  const history = useHistory();
  const [animate, setAnimate] = useState(false);

  const config = MODULE_CONFIG[module] || {
    title: 'This Module',
    icon: null,
    tagline: 'Something exciting is on the way.',
    gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    accent: '#764ba2',
  };

  useEffect(() => {
    if (module === 'ai-paper-maker') {
      history.replace('/utilities/ai-paper-maker');
      return undefined;
    }
    const t = setTimeout(() => setAnimate(true), 50);
    return () => clearTimeout(t);
  }, [module, history]);

  const goBack = () => history.push('/utilities/dashboard');

  return (
    <div
      className="coming-soon-module"
      style={{ '--module-gradient': config.gradient, '--module-accent': config.accent }}
    >
      <div className="csmm-bg-shapes">
        <div className="csmm-shape csmm-shape-1" />
        <div className="csmm-shape csmm-shape-2" />
        <div className="csmm-shape csmm-shape-3" />
      </div>

      <button type="button" className="csmm-back" onClick={goBack} aria-label="Go back">
        <span className="csmm-back-icon">←</span>
        <span>Back to Dashboard</span>
      </button>

      <div className={`csmm-card ${animate ? 'csmm-card-visible' : ''}`}>
        <div className="csmm-glow" />
        <div className="csmm-content">
          {config.icon && (
            <div className="csmm-icon-wrap">
              <img src={config.icon} alt={config.title} className="csmm-icon" />
            </div>
          )}
          <h1 className="csmm-title">{config.title}</h1>
          <p className="csmm-tagline">{config.tagline}</p>
          <div className="csmm-badge">
            <span className="csmm-badge-text">Coming Soon</span>
            <span className="csmm-dot" />
            <span className="csmm-dot" />
            <span className="csmm-dot" />
          </div>
          <p className="csmm-footer">We're working hard to bring you this feature. Stay tuned!</p>
        </div>
      </div>

      <div className="csmm-floating-dots">
        {[...Array(6)].map((_, i) => (
          <span key={i} className="csmm-fdot" style={{ '--i': i }} />
        ))}
      </div>
    </div>
  );
};

export default ComingSoonModule;
